var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFastFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0357 28.5587C22.0357 31.0118 20.6027 33 18.1496 33H8.9896C6.53651 33 5.10352 31.0118 5.10352 28.5587",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0072 23.0072C24.2334 23.0072 25.2279 24.2501 25.2279 25.783C25.2279 27.3159 24.2334 28.5587 23.0072 28.5587H4.13199C2.9058 28.5587 1.91138 27.3159 1.91138 25.783C1.91138 24.2501 2.9058 23.0072 4.13199 23.0072",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5624 23.0072H12.1339C11.9868 23.0073 11.8458 23.0657 11.7418 23.1696L9.87992 25.0314C9.85414 25.0572 9.82353 25.0777 9.78983 25.0917C9.75614 25.1056 9.72002 25.1128 9.68354 25.1128C9.64706 25.1128 9.61094 25.1056 9.57724 25.0917C9.54354 25.0777 9.51293 25.0572 9.48715 25.0314L7.6253 23.1696C7.52127 23.0657 7.38027 23.0073 7.23323 23.0072H3.57684C3.13513 23.0072 2.71151 22.8317 2.39918 22.5194C2.08684 22.2071 1.91138 21.7834 1.91138 21.3417C1.91138 20.9 2.08684 20.4764 2.39918 20.1641C2.71151 19.8517 3.13513 19.6763 3.57684 19.6763H23.5624C24.0041 19.6763 24.4277 19.8517 24.7401 20.1641C25.0524 20.4764 25.2279 20.9 25.2279 21.3417C25.2279 21.7834 25.0524 22.2071 24.7401 22.5194C24.4277 22.8317 24.0041 23.0072 23.5624 23.0072Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13184 18.8435V18.8283C4.13184 15.0116 7.25458 13.0144 11.0713 13.0144H16.0677C19.8843 13.0144 23.0071 15.0268 23.0071 18.8435V18.8283",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4148 7.46286L16.9311 11.902",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4556 33H27.1229C27.6831 32.9999 28.2226 32.7882 28.6333 32.4071C29.044 32.0261 29.2954 31.5039 29.3373 30.9452L31.8202 7.46286",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2279 7.46289L26.3382 3.02166L29.5997 1.91135",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.235 7.46289H32.9999",
    stroke: "#FCC436",
    strokeWidth: 2.22062,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFastFood);
export default __webpack_public_path__ + "static/media/iconFastFood.02bea2c6b611cd9dfdfa72fc92a56960.svg";
export { ForwardRef as ReactComponent };